import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const MEMORIAL_END = new Date("2026-10-28T00:00:00+01:00").getTime();
export function useMemorialActive() {
  const [on, setOn] = useState(Date.now() < MEMORIAL_END);
  useEffect(() => {
    if (!on) return undefined;
    const t = setTimeout(() => setOn(false), Math.min(MEMORIAL_END - Date.now(), 2 ** 31 - 1));
    return () => clearTimeout(t);
  }, [on]);
  return on;
}

const Bow = ({ cls }) => (
  <svg viewBox="0 0 24 32" className={`shrink-0 ${cls}`} aria-hidden>
    <path d="M12 13 C4 4 3 1 7 1 C10 1 12 6 12 13 C12 6 14 1 17 1 C21 1 20 4 12 13 Z" fill="#1f1f1f" />
    <path d="M12 12 L6 31 L9.5 28.5 L11 31.5 L12 14 Z" fill="#111" />
    <path d="M12 12 L18 31 L14.5 28.5 L13 31.5 L12 14 Z" fill="#2b2b2b" />
  </svg>
);

export const MourningRibbon = ({ testId = "mourning-ribbon", inline = false }) => useMemorialActive() && (
  <Link to="/gedenken" className="inline-flex items-center gap-1.5 shrink-0 select-none hover:opacity-80 transition-opacity" data-testid={testId} title="Gedenken an W. – 27.10.25 · Kerze anzünden" aria-label="Trauerflor: Gedenken an W., 27.10.25 – zur Gedenkseite">
    <Bow cls={inline ? "w-2.5 h-3.5" : "w-4 h-6"} />
    {inline ? (
      <span className="text-[10px] font-semibold text-slate-600 whitespace-nowrap">Gedenken an W. <span className="text-slate-400">· 27.10.25</span></span>
    ) : (
      <span className="flex flex-col leading-[1.05] text-[10px] font-semibold text-slate-600 whitespace-nowrap">
        <span>Gedenken an W.</span>
        <span className="text-slate-400 tracking-wide">27.10.25</span>
      </span>
    )}
  </Link>
);
